module.exports = __webpack_public_path__ + "media/components/Fastrack/routes/assets/add-ons/green-checkmark-e42976c2d82a692467a3c15f555c6398.svg";